<template>
    <div :id="this.$route.name">
        <Card add back >
            <template v-slot:header>
                <h4 class="d-inline">لـیست یـادآور</h4>
                <hr />
            </template>
            <template v-slot:content>
                    <BnpGrid v-if="$store.state.renderComponentGrid" :propsColumn="ColumnRiz" :propsRows="rowsRiz" :action="true" :hasRowNum="true">
                        <template slot="IsView" slot-scope="props">
                            <h6><span v-if="props.props.IsView == false" class="fas fa-eye-slash font-weight-bold hover-danger" title="دیده نشده"></span><span v-else class="fas fa-check-double font-weight-bold text-success" title="دیده شده"></span></h6>
                        </template>
                        <template slot="action-slot" slot-scope="props">
                            <a href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)" title="ویرایش"><h6><span class="fas fa-marker text-secondary hover-warning"></span></h6></a>
                            <a href="javascript:;" class="mr-2 badge" @click="OnDelete(props.props)" title="حذف" ><h6><span class="fas fa-trash-alt text-secondary hover-danger"></span></h6></a>
                            <a v-if="props.props.IsView == false" href="javascript:;" class="mr-2 badge" @click="ViewOk(props.props)" title="دیده شد"><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6></a>
                        </template>
                    </BnpGrid>
            </template>
        </Card>
    </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue';
export default {
    data() {
        return {
            rowsRiz: [],
            ColumnRiz: [{ name: 'AlarmText', label: 'متن یادآور', visibility: true },
                        { name: 'DateAlarm', label: 'تاریخ یادآور', visibility: true },
                        { name: 'IsView', label: 'وضعیت مشاهده', visibility: true }],
            DataAxios_GetdatRiz: { ArryfildValue: {} },
            DataAxiosDelete: {
                ArryfildValue: '',
                Method: 'Delete',
                Action: this.$route.name,
                Token: this.$session.get('Token'),
            },
            Sweet: ['حذف اطلاعات', 'آیا از حذف این اطلاعات اطمینان دارید ؟', 'warning', false],
            DataAxiosUpdate: {
                ArryfildValue: {},
                Method: 'put',
                Action: '',
                Token: this.$session.get('Token'),
                From: 'Body',
            },
        };
    },
    components: { Card, BnpGrid },
    mounted(){
        this.search()
    },
    methods:{
        search(){
            this.DataAxios_GetdatRiz.Action = 'Alarm/'+this.$session.get('UserInfo').tblUserId
        this.DataAxios_GetdatRiz.Method = 'Get';
        this.DataAxios_GetdatRiz.Token = this.$session.get('Token');
          this.$PostData(this.DataAxios_GetdatRiz)
            .then((data) => {
                if(data!=null){
                    this.rowsRiz=data
                }
                else{
                    this.rowsRiz=[]
                }
            }).finally(()=>{
                this.$store.state.renderComponentGrid = false
              this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true
              })
            });
        },
        OnEditNew(row){
            this.$router.push({ name: 'Detail' + this.$route.name, params: { Status: 'Edit', DataRow: row } })
        },
        OnDelete(data){
            this.$store.state.OldDataForLog = JSON.stringify(data)
            this.DataAxiosDelete.ArryfildValue = { id: data.Id }
             this.$DeleteDatapropmise(this.DataAxiosDelete, this.Sweet).then((result) => {
        if (result == true) {
          this.$store.state.renderComponentGrid = false
          var temparrayNum = this.rowsRiz.indexOf(this.rowsRiz.filter((x) => x.Id == data.Id)[0])
          this.rowsRiz.splice(temparrayNum, 1)


          var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'));
            var temp=UserAlarm.indexOf(UserAlarm.filter((x) => x.Id == data.Id)[0])
            UserAlarm.splice(temp,1);
            this.$cookies.set('UserAlarm',  JSON.stringify(UserAlarm))

              

          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true

          })
        }
      })
        },
        ViewOk(row){
            this.$store.state.OldDataForLog = JSON.stringify(row)
            row.IsView=true;
            row.TblUserGrpIdLastEdit = this.$session.get('UserInfo').tblUserGrpId
            this.DataAxiosUpdate.Action = this.$route.name
            this.DataAxiosUpdate.ArryfildValue = row
            this.$PutData_Body(this.DataAxiosUpdate)
                .then((data) => {
                if (data.status == 'Ok') {
                    var UserAlarm = JSON.parse(this.$cookies.get('UserAlarm'));
                    var temp=UserAlarm.indexOf(UserAlarm.filter((x) => x.Id == data.AlarmStatus.Id)[0])
                    UserAlarm.splice(temp,1);
                    UserAlarm.push(data.AlarmStatus);
                    this.$cookies.set('UserAlarm',  JSON.stringify(UserAlarm))
                    this.$SetLog(row, 0, 1);
                    this.$toasted.success('یادآور دیده شد', {
                    action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                        },
                    },
                    })

                    // this.$store.state.renderComponentGrid = false
                    // this.$nextTick(() => {
                    //     this.$store.state.renderComponentGrid = true
                    // })

                }else {
                    this.$toasted.error('مشکل در بروزرسانی یادآور لطفا مجدد تلاش کنید', {
                    action: {
                        text: 'بستن',
                        onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                        },
                    },
                    })
                    row.IsView =false
                }
            }).finally(() => {
                // this.search()
            }).catch((err)=>{
                row.IsView =false
            });
        }
    }
}
</script>
<style scoped>

</style>